export default __webpack_public_path__ + "static/media/icon-services-device-health-monitoring.b248d4fe.svg";